import React from 'react';
import './TourPage.css';

import { PageTitle, PagesNo, ShowcaseHeader, EmptyState, Tour, ToursSearch } from '../../../components';
import { useFilterLoading, useTourFilter } from '../../../utils';

import { FaMapMarkedAlt } from 'react-icons/fa';



const TourPage = () => {

  // Fetch filtered and paginated tour data using custom hook
  const {
    searchKeyword,
    matchingTours,
    sortOption,
    currentPage,
    displayedTours,
    handleFormSubmit,
    handleSort, 
    totalPages,
    handlePageChange,
  } = useTourFilter();

    // Use the custom hook `useFilterLoading` to determine if filtering is in progress
    const isFiltering = useFilterLoading(matchingTours, searchKeyword);

  return (
    <>

      {/* Page title */}
      <PageTitle title={'Tour packages'} page={'Tour packages'} />

      {/* Tours search component */}
      <ToursSearch onFormSubmit={handleFormSubmit} />

      <section className='tours'>

          {/* Check if there are matching tours */}
          {isFiltering ? null : matchingTours.length === 0 ? (
            <EmptyState
              icon={FaMapMarkedAlt}
              title={`No tours found`}
              message="We couldn’t find any tours that match your search. Try a different keyword or explore our full tour packages."
              buttonLink="Tours"
              buttonText="Browse All Tours"
            />
          ) : (
          <>

            {/* Tour header component */}
            <ShowcaseHeader
              showing={displayedTours.length}  // Number of tours currently displayed
              total={matchingTours.length}             // Total number of tours available
              sortOption={sortOption}         // Current sorting option
              handleSort={handleSort}         // Function to handle sorting changes
              isTour={true}                    // Indicates this is a tour showcase
            />

            {/* Tour container with grid layout */}
            <div className='tour-container grid'>
              {/* Render each tour component */}
              {displayedTours.map((tour) => {
                return(  
                  <Tour key={tour.id} tour={tour} /> // Render a Tour component for each tour
                )
              })
              }
            </div>

            {/* pagination component */}
            <PagesNo currentPage={currentPage} totalPages={totalPages} handlePageChange={handlePageChange} />
            
          </>
          )}
      </section>
    </>
  )
}

export default TourPage;